module.exports = __webpack_public_path__ + "static/media/logo.ddc5f83f.png";